import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import Select from 'react-select';
import { StyledSectionContainer } from '../../../../globalStyled';
import { fontUi, sectionTitle } from '../../../../theme/typography';
import { themedSelectMenuCss } from '../../../../theme/selectStyles';

export const StyledTransactionSelect = styled(Select)`
  bottom: 0;
  background-color: transparent;
  width: 160px;
  margin-right: 12px;
  font-size: 13px;

  .react-select__control {
    min-height: 28px;
    background-color: transparent;
    border: 0;
    box-shadow: none;
    ${fontUi};
    font-weight: 600;
    color: ${({ theme }) => theme.text};
  }
  .react-select__single-value,
  .react-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .react-select__placeholder {
    ${fontUi};
    line-height: 20px;
    font-weight: 500;
    color: ${({ theme }) => theme.textFaint};
  }
  .react-select__indicator-separator {
    display: none;
  }
  .react-select__indicator {
    padding: 0 4px;
    svg {
      fill: ${({ theme }) => theme.textFaint};
      width: 12px;
    }
  }
  .react-select__value-container {
    padding: 2px 5px;
    justify-content: flex-end;
  }
  ${themedSelectMenuCss}
`;

export const StyledHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  align-items: center;
`;

export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 25%;
  transform: translate(-25%, -50%);
`;

export const StyledSection = styled(StyledSectionContainer)`
  position: relative;
  overflow: hidden;

  h3 {
    ${sectionTitle};
    width: auto;
    font-size: 18px;
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const StyledContainer = styled.section`
  display: block;
`;

export const StyledTransactionContainer = styled.div`
  padding: 12px 16px 8px;
  background: transparent;
  max-height: 600px;
  overflow-y: auto;
`;

export const StyledButton = styled.div`
  height: 45px;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  width: 100%;
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
  svg {
    margin: 0 15px;
    * {
      fill: currentColor;
      stroke: currentColor;
    }
  }
  &[data-last='true'] {
    cursor: not-allowed;
    color: ${({ theme }) => theme.textFaint};
    * {
      cursor: not-allowed;
    }
    svg {
      transform: rotate(90deg);
    }
  }
  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: transparent;
    ${fontUi};
    font-weight: 700;
    font-size: 13px;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0.015em;
    color: inherit;
  }
`;
